import Base from '@studiometa/js-toolkit';
import LazyLoad from 'vanilla-lazyload';
// import YTPlayer from 'yt-player';
import { gsap } from 'gsap';
import Modal from '@studiometa/js-toolkit/components/Modal';
import Cookies from 'js-cookie';
import Plyr from 'plyr';
import { isDev } from './config';
import FormDl from './components/FormDl';
import Slider from './components/Slider';
import Popin from './components/Popin';
import Filters from './components/Filters';
import Search from './components/Search';

/**
 * Main App class.
 */
class App extends Base {
  /**
   * App config.
   * @return {Object}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      Filters,
      Modal,
      FormDl,
      Slider,
      Popin,
      Search,
    },
    options: {
      yturl: { type: String },
    },
    refs: [
      'body',
      'header',
      'textarea',
      'toggle',
      'submenu[]',
      'player[]',
      'footermenu[]',
      'welcome',
    ],
  };

  /**
   * Log a nice message when app is ready.
   *
   * @return {void}
   */
  mounted() {
    this.$log('mounted 🎉');

    // Welcome popin
    if (this.$refs.welcome && Cookies.get('welcome-popin') === undefined) {
      setTimeout(() => {
        this.$refs.welcome.open();

        const duration = parseFloat(this.$refs.welcome.$el.dataset.duration);
        if (duration > 0) {
          setTimeout(() => {
            this.$refs.welcome.close();
          }, duration * 1000);
        }
      }, 300);
    }

    // Lazyload
    this.lazyload = new LazyLoad({
      // eslint-disable-next-line camelcase
      elements_selector: '.js-lazy',
      threshold: 600,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains('js-lazy-error-placeholder')) {
          $el.lazyLoadPlaceholder = $el.src;
        }
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // Youtube player
    if (this.$refs.player) {
      this.$refs.player.forEach((p) => {
        const plyr = new Plyr(p, {
          controls: ['play-large', 'progress', 'current-time', 'mute', 'volume'],
          youtube: {
            controls: false,
            modestbranding: false,
            showinfo: false,
            // eslint-disable-next-line
            iv_load_policy: false,
          },
        });
        plyr.stop();

        // return;
        // const player = new YTPlayer(p.querySelector('.player__content'), {
        //   controls: false,
        //   modestBranding: false,
        //   related: false,
        //   annotations: false,
        // });

        // player.load(p.dataset.ytid);

        // const trigger = p.querySelector('.trigger-play');
        // trigger.addEventListener('click', (e) => {
        //   e.preventDefault();
        //   player.play();
        // });
        // player.on('playing', () => {
        //   p.classList.add('onplaying');
        // });
        // player.on('paused', () => {
        //   p.classList.remove('onplaying');
        // });
      });
    }
  }

  /** */
  onToggleClick(e) {
    e.preventDefault();

    this.$refs.body.classList.toggle('open-menu');
  }

  /**
   * Submenu mobile submenu
   *
   * @param {Event} e
   */
  onSubmenuClick(e, index) {
    e.preventDefault();

    this.$refs.submenu[index].classList.toggle('active');

    const next = this.$refs.submenu[index].nextElementSibling;
    if (next) {
      next.classList.toggle('h-0');
    }
  }

  /** */
  onFiltersUpdated() {
    this.lazyload.update();
  }

  /**
   * Fix menu when scrolling
   */
  scrolled() {
    if (window.scrollY > 0) {
      this.$refs.body.classList.add('fixed-menu');
    } else {
      this.$refs.body.classList.remove('fixed-menu');
    }
  }

  /**
   * Mouseenter of menu items
   *
   * @param {*} event
   * @param {*} index
   */
  onHeaderMouseenter() {
    this.$refs.body.classList.add('hover-menu');
  }

  /**
   * Mouse leave of menu items
   *
   * @param {*} event
   * @param {*} index
   */
  onHeaderMouseleave() {
    this.$refs.body.classList.remove('hover-menu');
  }

  /**
   * Auto expand textarea
   *
   * @param {Event} e
   */
  onTextareaInput(e) {
    const field = e.target;

    if (!field) return;

    // Reset field height
    field.style.height = 'inherit';

    // Get the computed styles for the element
    const computed = window.getComputedStyle(field);

    // Calculate the height
    const height =
      parseInt(computed.getPropertyValue('border-top-width'), 10) +
      // parseInt(computed.getPropertyValue('padding-top'), 10) +
      field.scrollHeight +
      // parseInt(computed.getPropertyValue('padding-bottom'), 10) +
      parseInt(computed.getPropertyValue('border-bottom-width'), 10);

    field.style.height = `${height}px`;
  }

  /**
   * Footer accordion
   *
   * @param {Event} e
   */
  onFootermenuClick(e, index) {
    e.preventDefault();

    const next = this.$refs.footermenu[index].nextElementSibling;
    if (next) {
      let height = 0;
      for (let i = 0; i < next.children.length; i += 1) {
        height += parseFloat(next.children[i].offsetHeight);
      }

      gsap.to(next, { duration: 0.3, height: next.offsetHeight === 0 ? `${height}px` : '0px' });
    }
  }

  /**
   *
   */
  onModalClose() {
    Cookies.set('welcome-popin', true);
  }
}

const app = new App(document.documentElement);
app.$mount();
export default app;
